import Vue from "vue";

export default {
  getCompanyStatutorySettings({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/payroll/salarymanagement/settings/company-statutory-settings")
        .then(response => {
          const data =
            response.data && response.data.data
              ? response.data.data
              : response.data;
          const payload = {
            nhf_enabled: data.nhf_enabled > 0,
            nhis_enabled: data.nhis_enabled > 0,
            nhis_rate: data.nhis_rate || 5.0,
            nsitf_enabled: data.nsitf_enabled > 0,
            itf_enabled: data.itf_enabled > 0,
          };
          commit("companyStatutorySettings", payload);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCompanyStatutorySettings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          "/payroll/salarymanagement/settings/company-statutory-settings",
          payload
        )
        .then(response => {
          const data =
            response.data && response.data.data
              ? response.data.data
              : response.data;
          commit("companyStatutorySettings", data || {});
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllPayBreakdown({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };
      Vue.$http
        .get("/payroll/salarymanagement/settings/pay-breakdown", { params })
        .then(response => {
          commit("payBreakdowns", response.data.results);
          commit("totalPayBreakdown", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getFullPayBreakdown() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/payroll/salarymanagement/settings/pay-breakdown")
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createPayBreakdown({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/salarymanagement/settings/pay-breakdown`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  updatePayBreakdown(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          `/payroll/salarymanagement/settings/pay-breakdown/${data.id}`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPayBreakdownById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/salarymanagement/settings/pay-breakdown/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deletePayBreakdown(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/salarymanagement/settings/pay-breakdown/[${id}]`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAllExtraAllowances({ commit, state }, withOutPagination) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };
      Vue.$http
        .get(
          "/payroll/salarymanagement/settings/extraallowance",
          !withOutPagination ? { params } : null
        )
        .then(response => {
          commit("extraAllowances", response.data.results);
          commit("totalExtraAllowance", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  createExtraAllowance({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/salarymanagement/settings/extraallowance`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  updateExtraAllowance(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          `/payroll/salarymanagement/settings/extraallowance/${data.id}`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExtraAllowanceById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/salarymanagement/settings/extraallowance/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeEmployeeToPayPackage(_, payload) {
    const { payPackageId, ...payloadLeft } = payload.assignments;
    const payloadToSubmit = { assignments: [payloadLeft] };
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          `payroll/salarymanagement/pay-packages/${payPackageId}/un-assign`,
          payloadToSubmit
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteExtraAllowance(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/salarymanagement/settings/extraallowance/[${id}]`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleSizeChangePayBreakdown({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getAllPayBreakdown");
  },

  handleCurrentChangePayBreakdown({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllPayBreakdown");
  },
  handleSizeChangeBatching({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getAllBatchingGroup");
  },

  handleCurrentChangeBatching({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllBatchingGroup");
  },
  handleSizeChangeExtraAllowance({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getAllExtraAllowances");
  },

  handleCurrentChangeExtraAllowance({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllExtraAllowances");
  },

  handleSizeChangeRemittance({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getAllCompanyRemittance");
  },

  handleCurrentChangeRemittance({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllCompanyRemittance");
  },

  handleSizeChangeStatutory({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getAllStatutoryD");
  },

  handleCurrentChangeStatutory({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllStatutoryD");
  },

  getAllCompanyRemittance({ commit, state }, withOutPagination) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };
      Vue.$http
        .get(
          "/payroll/salarymanagement/settings/company-remittance",
          !withOutPagination ? { params } : null
        )
        .then(response => {
          commit("companyRemittance", response.data.results);
          commit("totalCompanyRemittance", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  createCompanyRemittance({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/salarymanagement/settings/company-remittance`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  updateCompanyRemittance(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/payroll/salarymanagement/settings/company-remittance`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getCompanyRemittanceById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/salarymanagement/settings/company-remittance/${id}`)
        .then(response => {
          commit("currentCompanyRemittance", response.data);

          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteCompanyRemittance(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/salarymanagement/settings/company-remittance/[${id}]`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAllBatchingGroup({ commit, state }, noPagination) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      let params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };
      if (noPagination) {
        params = {};
      }
      Vue.$http
        .get("/payroll/salarymanagement/settings/batching-and-grouping", {
          params,
        })
        .then(response => {
          commit("batchingGroups", response.data.results);
          commit("totalBatchingGroup", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  createBatchingGroup({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/payroll/salarymanagement/settings/batching-and-grouping`,
          params
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  updateBatchingGroup(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          `/payroll/salarymanagement/settings/batching-and-grouping/${id}`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBatchingGroupById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/salarymanagement/settings/batching-and-grouping/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteBatchingGroup(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(
          `/payroll/salarymanagement/settings/batching-and-grouping/${id}`
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          // commit("tableLoader", false);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getBranches({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          commit("branches", response.data.results);
          resolve(response.data.results);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getEmployeeGrades({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/settings/grades")
        .then(response => {
          commit("employeeGrades", response.data.results);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDepartments({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("organization/departments")
        .then(response => {
          commit("departments", response.data.results);
          resolve(response.data.results);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTeams({ commit, state }) {
    return new Promise((resolve, reject) => {
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
      };
      Vue.$http
        .get("organization/teams", { params })
        .then(response => {
          commit("teams", response.data.results);
          resolve(response.data.results);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAllStatutoryD({ commit, state }, withOutPagination) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };
      Vue.$http
        .get(
          "/payroll/salarymanagement/settings/statutory-deduction",
          !withOutPagination ? { params } : null
        )
        .then(response => {
          commit("statutoryDs", response.data.results);
          commit("totalStatutoryDs", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  createStatutoryD({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/salarymanagement/settings/statutory-deduction`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  updateStatutoryD(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          `/payroll/salarymanagement/settings/statutory-deduction/${id}`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getStatutoryDById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/salarymanagement/settings/statutory-deduction/${id}`)
        .then(response => {
          commit("currentStatutoryDeduction", response.data);

          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteStatutoryD(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/salarymanagement/settings/statutory-deduction/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          // commit("tableLoader", false);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createPayPackage(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/payroll/salarymanagement/pay-packages`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPayPackages({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const params = {
        page: state.currentPageForPayPackage,
        perPage: state.perPageForPayPackage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };
      Vue.$http
        .get(`/payroll/salarymanagement/pay-packages`, {
          params,
        })
        .then(response => {
          commit("payPackages", response.data.results);
          commit("totalPayPackages", response.data.total);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getPayPackage(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/payroll/salarymanagement/pay-packages/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updatePayPackage(_, payload) {
    const { id, formData } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/payroll/salarymanagement/pay-packages/${id}`, formData)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deletePayPackage(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/payroll/salarymanagement/pay-packages/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleCurrentChangeForPayPackage({ commit, dispatch }, page) {
    commit("currentPageForPayPackage", page);
    dispatch("getPayPackages");
  },

  handleSizeChangeForPayPackage({ commit, dispatch }, perPage) {
    commit("perPageForPayPackage", perPage);
    commit("currentPageForPayPackage", 1);
    dispatch("getPayPackages");
  },
  getSalarySchedule({ commit, state }, payload) {
    const params = {
      ...(payload || state.formDataForSalarySchedule),
      page: state.currentPageForSalary,
      perPage: state.perPageForSalary,
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      if (!state.formDataForSalarySchedule && !payload) {
        commit("tableLoader", false);
        reject({ message: "No parameters set to get salary schedule" });
        return;
      }
      Vue.$http
        .post(`/payroll/salarymanagement/salary-schedules`, params)
        .then(response => {
          commit("tableLoader", false);
          commit("salarySchedule", response.data.results);
          commit("totalSalarySchedule", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  handleCurrentChangeForSalary({ commit, dispatch }, page) {
    commit("currentPageForSalary", page);
    dispatch("getSalarySchedule");
  },

  handleSizeChangeForSalary({ commit, dispatch }, perPage) {
    commit("perPageForSalary", perPage);
    commit("currentPageForSalary", 1);
    dispatch("getSalarySchedule");
  },
  downloadSalaryScheduleReport({ state }, format) {
    const params = {
      ...state.formDataForSalarySchedule,
      page: state.currentPageForSalary,
      perPage: state.perPageForSalary,
    };

    return new Promise((resolve, reject) => {
      if (!state.formDataForSalarySchedule) {
        reject({ message: "No parameters set to get salary schedule" });
        return;
      }
      Vue.$http
        .post(
          `/payroll/salarymanagement/salary-schedules/download/${format}`,
          params
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  uploadSalarySchedule({ commit, state }, payload) {
    const updatedPayload = { ...payload, mode: "upload" };
    const updatedFormDataForSalarySchedule = {
      ...state.formDataForSalarySchedule,
      mode: "upload",
    };
    const params = {
      ...((payload && updatedPayload) ||
        (state.formDataForSalarySchedule && updatedFormDataForSalarySchedule)),
      page: state.currentPageForSalary,
      perPage: state.perPageForSalary,
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      if (!state.formDataForSalarySchedule && !payload) {
        commit("tableLoader", false);
        reject({ message: "No parameters set to get salary schedule" });
        return;
      }
      Vue.$http
        .post(`/payroll/salarymanagement/salary-schedules`, params)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getPaymentUploads({ state, commit }) {
    const params = {
      type: "salary",
      page: state.currentPageForPaymentUploads,
      per_page: state.perPageForPaymentUploads,
      // ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      ...(state.filterDate != "" && { year_month: state.filterDate }),
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/payment-upload/salary`, { params })
        .then(response => {
          commit("tableLoader", false);
          commit("paymentUploads", response.data.results);
          commit("totalPaymentUploads", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  handleCurrentChangeForUploadedSalary({ commit, dispatch }, page) {
    commit("currentPageForPaymentUploads", page);
    dispatch("getPaymentUploads");
  },

  handleSizeChangeForUploadedSalary({ commit, dispatch }, perPage) {
    commit("perPageForPaymentUploads", perPage);
    commit("currentPageForPaymentUploads", 1);
    dispatch("getPaymentUploads");
  },
  exportPayment(_, payload) {
    const { format, transaction_id } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `payroll/salarymanagement/payment-upload/salary/${transaction_id}/export/${format}`,
          payload
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeScheduleStatus(_, payload) {
    const { upload_type, transaction_id, schedule_ids, action } = payload;
    const params = {
      schedule_ids,
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(
          `payroll/payment-management/payment-upload/${upload_type}/${transaction_id}/schedules/${action}`,
          params
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPaymentUploadDetails({ commit, state }, payload) {
    const params = {
      page: state.currentPageForPaymentUploadDetails,
      per_page: state.perPageForPaymentUploadDetails,
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      const { transaction_id } = payload;
      Vue.$http
        .get(
          `payroll/payment-management/payment-upload/salary/${transaction_id}/schedules`,
          {
            params,
          }
        )
        .then(response => {
          commit("tableLoader", false);
          commit("paymentUploadDetails", response.data.results);
          commit("totalPaymentUploadDetails", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  handleCurrentChangeForPaymentUploadDetails(
    { commit, dispatch },
    { value, transaction_id }
  ) {
    commit("currentPageForPaymentUploadDetails", value);
    dispatch("getPaymentUploadDetails", { transaction_id });
  },

  handleSizeChangeForPaymentUploadDetails(
    { commit, dispatch },
    { value, transaction_id }
  ) {
    commit("perPageForPaymentUploadDetails", value);
    commit("currentPageForPaymentUploadDetails", 1);
    dispatch("getPaymentUploadDetails", { transaction_id });
  },
  getApprovedPayments({ state, commit }) {
    const params = {
      page: state.currentPageForApprovedPayments,
      per_page: state.perPageForApprovedPayments,
      ...(state.filterDate != "" && { year_month: state.filterDate }),
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/approved-payments/salary`, {
          params,
        })
        .then(response => {
          commit("tableLoader", false);
          commit("approvedPayments", response.data.results);
          commit("totalApprovedPayments", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },

  handleCurrentChangeForApprovedPayments({ commit, dispatch }, page) {
    commit("currentPageForApprovedPayments", page);
    dispatch("getApprovedPayments");
  },

  handleSizeChangeForApprovedPayments({ commit, dispatch }, perPage) {
    commit("perPageForApprovedPayments", perPage);
    commit("currentPageForApprovedPayments", 1);
    dispatch("getApprovedPayments");
  },

  getApprovedPaymentSchedules({ state, commit }, { transaction_id }) {
    const params = {
      page: state.currentPageForApprovedPaymentSchedules,
      per_page: state.perPageForApprovedPaymentSchedules,
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(
          `payroll/payment-management/approved-payments/salary/${transaction_id}/schedules`,
          {
            params,
          }
        )
        .then(response => {
          commit("tableLoader", false);
          commit("approvedPaymentSchedules", response.data.results);
          commit("totalApprovedPaymentSchedules", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  handleCurrentChangeForApprovedPaymentSchedules(
    { commit, dispatch },
    { page, transaction_id }
  ) {
    commit("currentPageForApprovedPaymentSchedules", page);
    dispatch("getApprovedPaymentSchedules", { transaction_id });
  },

  handleSizeChangeForApprovedPaymentSchedules(
    { commit, dispatch },
    { perPage, transaction_id }
  ) {
    commit("perPageForApprovedPaymentSchedules", perPage);
    commit("currentPageForApprovedPaymentSchedules", 1);
    dispatch("getApprovedPaymentSchedules", { transaction_id });
  },
  exportApprovedPayment(_, { format, transaction_id, formData }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `payroll/payment-management/approved-payments/salary/${transaction_id}/schedules/export/${format}`,
          formData
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createPayOption(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`payroll/payment-management/settings/payment-options`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getMandates({ state, commit }) {
    const params = {
      page: state.currentPageForMandates,
      per_page: state.perPageForMandates,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoader", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/settings/payment-options/mandates`, {
          params,
        })
        .then(response => {
          commit("tableLoader", false);
          commit("mandates", response.data.results);
          commit("totalMandate", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getMandate(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`payroll/payment-management/settings/payment-options/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleCurrentChangeForMandates({ commit, dispatch }, page) {
    commit("currentPageForMandates", page);
    dispatch("getMandates");
  },

  handleSizeChangeForMandates({ commit, dispatch }, perPage) {
    commit("perPageForMandates", perPage);
    commit("currentPageForMandates", 1);
    dispatch("getMandates");
  },
};
